<hgroup class="flex flex-col-reverse gap-4 xs:flex-col xs:gap-10">
  <h2 class="typo-h2 text-text-primary xs:font-poppins xs:text-[26px] xs:font-medium xs:leading-8 xs:tracking-[-0.7px]">
    {{ 'baa_signup_info_title' | translate }}
  </h2>

  <p class="text-primary-blue">
    <span class="typo-h5-semibold">{{ 'baa_signup_info_feature1' | translate }} </span>
    <span class="typo-h5-book">{{ 'baa_signup_info_feature2' | translate }}</span>
  </p>
</hgroup>

<div class="mt-4 flex flex-col gap-3 xs:mt-3">
  <div class="flex gap-3">
    <div class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-blue text-[11px] font-semibold text-text-white">
      1
    </div>
    <div class="flex flex-col gap-1">
      <p class="typo-h4-semibold text-text-secondary">
        {{ 'baa_signup_info_step1' | translate }}
      </p>
      <p class="typo-h5-light text-text-tertiary">
        {{ 'baa_signup_info_step1_desc' | translate }}
      </p>
    </div>
  </div>

  <div class="flex gap-3">
    <div class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-blue text-[11px] font-semibold text-text-white">
      2
    </div>
    <div class="flex flex-col gap-1">
      <p class="typo-h4-semibold text-text-secondary">
        {{ 'baa_signup_info_step2' | translate }}
      </p>
      <p class="typo-h5-light text-text-tertiary">
        {{ 'baa_signup_info_step2_desc' | translate }}
      </p>
    </div>
  </div>
</div>

@if (service.signerEmailSignal()) {
  <div class="mt-6 flex flex-col items-center gap-1 rounded-2xl bg-background-light-grey p-5 xs:mt-10">
    <p class="typo-h5-book text-text-tertiary">
      {{ 'baa_signup_info_email_label' | translate }}
    </p>
    <p class="typo-h5-medium text-text-secondary">
      {{ service.signerEmailSignal() }}
    </p>
  </div>
}

<div class="mt-2 xs:mt-4">
  <button
    class="btn-primary w-full justify-center"
    [disabled]="service.isRegistrationLoadingSignal() || service.isResolveLoadingSignal()"
    (click)="onContinue()"
  >
    {{ 'baa_signup_info_cta' | translate }}
  </button>
</div>

<div class="my-6 h-px w-full bg-background-disabled xs:hidden" aria-hidden="true"></div>

<p class="typo-h5-extralight mt-3 text-center text-text-tertiary">
  {{ 'baa_signup_info_already_have_account' | translate }}
  <a class="typo-h5-extralight text-primary-blue underline" [routerLink]="[...ffdNotesRoutePrefix(), routes.login]">
    {{ 'baa_signup_info_log_in' | translate }}
  </a>
</p>
